import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { MainLayout } from "@/components/MainLayout";
import OverviewCenter from "./pages/OverviewCenter";
import BusinessModules from "./pages/BusinessModules";
import EnterpriseDigital from "./pages/EnterpriseDigital";
import Login from "./pages/Login";
import Factory from "./pages/Factory";
import FactoryDetails from "./pages/FactoryDetails";
import { FlowChart } from "./pages/FlowChart";
import DigitalTwin from "./pages/DigitalTwin";
import LogisticsDemo from "./pages/LogisticsDemo";
import NotFound from "./pages/NotFound";
import Callback from "./pages/Callback";
import SkuCalendar from "./pages/SkuCalendar";
import LogisticsMap from "./pages/LogisticsMap";
import ReportPage from "./pages/ReportPage";
import InventoryForecast from "./pages/InventoryForecast";
import OnSaleProducts from "./pages/OnSaleProducts";
import OnSaleSpuProducts from "./pages/OnSaleSpuProducts";
import OnSaleSpuProductsArea from "./pages/OnSaleSpuProductsArea";
import ForecastMapStatus from "./pages/ForecastMapStatus";
import SupplyChainMap from "./pages/SupplyChainMap";
import SupplyChainSubPage from "./pages/SupplyChainSubPage";
import FinancialSpuBudgetComparison from "./pages/FinancialSpuBudgetComparison";

// 创建 QueryClient 实例
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

export default function App() {
  return (
    // 最外层是 QueryClientProvider
    <QueryClientProvider client={queryClient}>
      {/* 然后是 AuthProvider */}
      <AuthProvider>
        {/* 接着是 BrowserRouter */}
        <BrowserRouter basename="/">
          {/* 最后是 UI 相关的 Providers */}
          <TooltipProvider>
            {/* 全局消息提示组件 */}
            <Toaster />
            <Sonner />
            
            {/* 路由配置 */}
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/callback" element={<Callback />} />

              {/* 主布局：左侧菜单 + 顶栏 + 内容区 */}
              <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                <Route index element={<OverviewCenter />} />
                <Route path="business" element={<BusinessModules />} />
                <Route path="enterprise" element={<EnterpriseDigital />} />
                <Route path="factory" element={<Factory />} />
                <Route path="factory/:id" element={<FactoryDetails />} />
                <Route path="sku-calendar" element={<SkuCalendar />} />
                <Route path="logistics" element={<LogisticsMap />} />
                <Route path="InventoryForecast" element={<InventoryForecast />} />
                <Route path="OnSaleProducts" element={<OnSaleProducts />} />
                <Route path="OnSaleSpuProducts" element={<OnSaleSpuProducts />} />
                <Route path="OnSaleSpuProductsArea" element={<OnSaleSpuProductsArea />} />
                <Route path="forecast-map-status" element={<ForecastMapStatus />} />
                <Route path="enterprise/supply-chain" element={<SupplyChainMap />} />
                <Route path="enterprise/supply-chain/:systemId" element={<SupplyChainSubPage />} />
                <Route path="financial-spu-budget-comparison" element={<FinancialSpuBudgetComparison />} />
                <Route path="report/:searchId" element={<ReportPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </TooltipProvider>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
